import { connect } from 'react-redux';
import HoverWobble from './HoverWobble';

const mapStateToProps = state => ({

});

const mapDispatchToProps = {
  
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HoverWobble);
